import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Component
import Row from 'ui/Row'
import Col from 'ui/Col'
import Modal from 'ui/Modal'
import Button from 'ui/Button'
import IconQuestion from 'ui/Icons/IconQuestion'
import Text from 'ui/Text'

import './PopupConfirm.scss'

export const PopupConfirm = ({
  title,
  message,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  size,
  ...props
}) => {
  // State
  const [visible, setVisible] = useState(true)
  const [loading, setLoading] = useState(false)

  const onCancelClick = () => {
    // Custom callback
    if (onCancel) {
      return onCancel({
        setVisible,
      })
    }

    setVisible(false)
  }

  const onConfirmClick = () => {
    // Custom callback
    if (onConfirm) {
      return onConfirm({
        setVisible,
        setLoading,
      })
    }

    setVisible(false)
  }

  return (
    <Modal show={visible} size={size} className="x-confirm-wrap" {...props}>
      <div className="wrap-icon">
        <IconQuestion />
      </div>
      <Text size={24} bold paddingBottom={5} color="#000000">
        {title}
      </Text>
      <Text size={18} color="#000000" paddingBottom={20}>
        {message}
      </Text>

      <Row multiline>
        <Col xs={12} sm={6}>
          <Button
            block
            variant="outline-primary"
            disabled={loading}
            onClick={onCancelClick}
          >
            {cancelText}
          </Button>
        </Col>

        <Col xs={12} sm={6}>
          <Button block loading={loading} onClick={onConfirmClick}>
            {confirmText}
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}

PopupConfirm.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  size: PropTypes.string,
}

PopupConfirm.defaultProps = {
  title: null,
  message: null,
  cancelText: 'Cancel',
  confirmText: 'Yes, proceed',
  onCancel: null,
  onConfirm: null,
  size: 'md',
}

export default PopupConfirm
